module.exports = __webpack_public_path__ + "img/icon-bonus-info.e265898c.svg";